// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"d149da69","134":"e421debb","249":"35e84fd7","271":"5e8af4a8","345":"4946435b","374":"b8dc66c1","453":"20359781","467":"3c261437","507":"8b54e22b","610":"62b08b59","765":"89456fc1","778":"32dcf596","836":"c3d1ec61","917":"9c2375c0"}[chunkId] + ".chunk.js";
};